// This function gets the sidebar section from route and opens the according sidebar part
currentPagePath = window.location.pathname;
// Split route from path
currentRoute = currentPagePath.substring(currentPagePath.lastIndexOf("/") + 1);

switch (currentRoute) {
    case 'documentation':
        openSection(document.querySelector('.summary-sidebar-section'));
        break;
    case 'getting-started':
        openSection(document.querySelector('.getting-started-sidebar-section'));
        break;
    case 'converting-a-file':
        openSection(document.querySelector('.converting-a-file-sidebar-section'));
        break;
    case 'uploading-files':
        openSection(document.querySelector('.uploading-files-sidebar-section'));
        break;
    case 'conversion-with-options':
        openSection(document.querySelector('.conversion-with-options-sidebar-section'));
        break;
    case 'conversion-examples':
        openSection(document.querySelector('.conversion-examples-sidebar-section'));
        break;
    case 'input-types':
        openSection(document.querySelector('.input-types-sidebar-section'));
        break;
    case 'advanced-api-calls':
        openSection(document.querySelector('.advanced-api-calls-sidebar-section'));
        break;
    case 'metadata-handling':
        openSection(document.querySelector('.metadata-handling-sidebar-section'));
        break;
    case 'statistics':
        openSection(document.querySelector('.statistics-sidebar-section'));
        break;
    case 'contracts':
        openSection(document.querySelector('.contracts-sidebar-section'));
        break;
    case 'errors-and-warnings':
        openSection(document.querySelector('.errors-and-warnings-sidebar-section'));
        break;
    case 'special-operations':
        openSection(document.querySelector('.special-operations-sidebar-section'));
        break;
}

// Sidebar menu section
sectionElements = document.querySelectorAll('.sidebar-section-link');
sectionElements.forEach(
    function (sectionElement) {
        //Add click listener for every sidebar section
        sectionElement.addEventListener('click', function (event) {

            // Close all open menus except clicked one
            closeAllSectionsExceptOne(sectionElement, sectionElements);

            // If section is already opened, close it, else open it
            var isOpen = sectionElement.closest('.sidebar-section').classList.contains('sidebar-open');
            if (isOpen) {
                closeSection(sectionElement);
            } else {
                openSection(sectionElement);
            }

        });
    }
);

// Close all open menus except clicked one
function closeAllSectionsExceptOne(sectionToLeaveOpen, sectionList) {
    sectionList.forEach(function (item) {
        if (item != sectionToLeaveOpen) {
            closeSection(item);
        }
    });
}

// Open specific menu
function openSection(sectionElement) {
    // Add green sidebar border, open submenu, rotate icon
    sectionElement.querySelector('.menu-arrow').classList.add('menu-icon-active');
    sectionElement.closest('.sidebar-section').classList.add('sidebar-border');
    sectionElement.closest('.sidebar-section').classList.add('sidebar-open');
    sectionElement.querySelector('.sidebar-list-link').classList.add('hide-border-left');
}

// Close specific menu
function closeSection(sectionElement) {
    // Add green sidebar border, open submenu, rotate icon
    sectionElement.querySelector('.menu-arrow').classList.remove('menu-icon-active');
    sectionElement.closest('.sidebar-section').classList.remove('sidebar-border');
    sectionElement.closest('.sidebar-section').classList.remove('sidebar-open');
    sectionElement.querySelector('.sidebar-list-link').classList.remove('hide-border-left');
}
